import { useContext, useState } from "react";
import { TextField, Grid, IconButton, Typography, Box } from "@mui/material";
import { Filters } from "../../models/Filters";
import { ArrowDown, ArrowUp } from "@phosphor-icons/react";
import { LanguageContext } from "../../globals/LanguageContext";

type NameFilterProps = {
  filters: Filters;
  onChange: (val: any) => void;
};

export function NameFilter({ filters, onChange }: NameFilterProps) {
  const [inputValue, setInputValue] = useState("");
  const { dictionary } = useContext(LanguageContext);
  const handleInputChange = (val: string) => {
    setInputValue(val);
    onChange({ ...filters, name: val });
  };

  const toggleSortDirection = () => {
    const current = filters.sortDirection?.direction || "asc";
    onChange({
      ...filters,
      sortDirection: {
        key: "name",
        direction: current === "asc" ? "desc" : "asc",
      },
    });
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Box display="flex" alignItems="center">
          <Typography variant="subtitle1" sx={{ mr: 1 }}>
            {dictionary.filters.name}
          </Typography>
          <IconButton onClick={toggleSortDirection} size="small">
            {filters.sortDirection?.direction === "desc" ? (
              <ArrowDown fontSize="small" />
            ) : (
              <ArrowUp fontSize="small" />
            )}
          </IconButton>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <TextField
          label="Name"
          fullWidth
          value={inputValue}
          onChange={(e) => handleInputChange(e.target.value)}
        />
      </Grid>
    </Grid>
  );
}
